/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddStageParticipantsRequestDto } from '../models';
// @ts-ignore
import type { EligibleSurveyParticipantsResponseDto } from '../models';
// @ts-ignore
import type { EmployeeSurveyQuestionIdsResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { StageParticipantsResponseDto } from '../models';
// @ts-ignore
import type { SurveyAssignRequestDto } from '../models';
// @ts-ignore
import type { TestTermParticipantStatusDto } from '../models';
/**
 * StageParticipantApi - axios parameter creator
 * @export
 */
export const StageParticipantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds employees from the certification participant pool to this specific stage. Skips employees already assigned to the stage. 
         * @summary Add participants to stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStageParticipants: async (certificationId: number, stageId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('addStageParticipants', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('addStageParticipants', 'stageId', stageId)
            // verify required parameter 'addStageParticipantsRequestDto' is not null or undefined
            assertParamExists('addStageParticipants', 'addStageParticipantsRequestDto', addStageParticipantsRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addStageParticipantsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds an employee to a SURVEY stage and assigns specific questions. Either provide questionIds (specific questions to assign) or sourceEmployeeId (copy questions from another participant). Creates stage participant, survey question assignments, survey participant preview, and certification participant records. 
         * @summary Add participant to survey stage with question assignment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {SurveyAssignRequestDto} surveyAssignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSurveyParticipant: async (certificationId: number, stageId: number, surveyAssignRequestDto: SurveyAssignRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('assignSurveyParticipant', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('assignSurveyParticipant', 'stageId', stageId)
            // verify required parameter 'surveyAssignRequestDto' is not null or undefined
            assertParamExists('assignSurveyParticipant', 'surveyAssignRequestDto', surveyAssignRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/participants/survey-assign`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyAssignRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the IDs of survey questions currently assigned to the given employee in the SURVEY stage. Used by the \"add participant — copy from another participant\" UX to preselect questions before assigning them to a new participant. 
         * @summary List question IDs assigned to an employee in the survey stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSurveyQuestionIds: async (certificationId: number, stageId: number, employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getEmployeeSurveyQuestionIds', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getEmployeeSurveyQuestionIds', 'stageId', stageId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployeeSurveyQuestionIds', 'employeeId', employeeId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/participants/{employeeId}/survey-question-ids`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns paginated list of employees assigned to this certification stage. Supports search by employee name/email (partial match). Includes term participation history for each participant. 
         * @summary Get stage participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee name or email (partial match)
         * @param {Array<number>} [termIds] Filter by term IDs (participants who have participation in any of the given terms)
         * @param {TestTermParticipantStatusDto} [termStatus] Filter by term participation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageParticipants: async (certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, termIds?: Array<number>, termStatus?: TestTermParticipantStatusDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getStageParticipants', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getStageParticipants', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (termIds) {
                localVarQueryParameter['termIds'] = termIds.join(COLLECTION_FORMATS.csv);
            }

            if (termStatus !== undefined) {
                localVarQueryParameter['termStatus'] = termStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns active employees that are NOT yet participants of the given stage. Used by the \"Dodaj uczestnika do ankiety\" picker — the source-side field of that dialog uses a different endpoint (existing survey participants). 
         * @summary Search employees eligible to be added to the SURVEY stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] Free-text search across first name, last name, email and SAP number.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEligibleSurveyParticipants: async (certificationId: number, stageId: number, search?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('listEligibleSurveyParticipants', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('listEligibleSurveyParticipants', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/eligible-survey-participants`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove participant from stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeStageParticipant: async (certificationId: number, stageId: number, participantId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('removeStageParticipant', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('removeStageParticipant', 'stageId', stageId)
            // verify required parameter 'participantId' is not null or undefined
            assertParamExists('removeStageParticipant', 'participantId', participantId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/participants/{participantId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"participantId"}}`, encodeURIComponent(String(participantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StageParticipantApi - functional programming interface
 * @export
 */
export const StageParticipantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StageParticipantApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds employees from the certification participant pool to this specific stage. Skips employees already assigned to the stage. 
         * @summary Add participants to stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStageParticipants(certificationId: number, stageId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStageParticipants(certificationId, stageId, addStageParticipantsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StageParticipantApi.addStageParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds an employee to a SURVEY stage and assigns specific questions. Either provide questionIds (specific questions to assign) or sourceEmployeeId (copy questions from another participant). Creates stage participant, survey question assignments, survey participant preview, and certification participant records. 
         * @summary Add participant to survey stage with question assignment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {SurveyAssignRequestDto} surveyAssignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignSurveyParticipant(certificationId: number, stageId: number, surveyAssignRequestDto: SurveyAssignRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignSurveyParticipant(certificationId, stageId, surveyAssignRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StageParticipantApi.assignSurveyParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the IDs of survey questions currently assigned to the given employee in the SURVEY stage. Used by the \"add participant — copy from another participant\" UX to preselect questions before assigning them to a new participant. 
         * @summary List question IDs assigned to an employee in the survey stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeSurveyQuestionIds(certificationId: number, stageId: number, employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeSurveyQuestionIdsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeSurveyQuestionIds(certificationId, stageId, employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StageParticipantApi.getEmployeeSurveyQuestionIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns paginated list of employees assigned to this certification stage. Supports search by employee name/email (partial match). Includes term participation history for each participant. 
         * @summary Get stage participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee name or email (partial match)
         * @param {Array<number>} [termIds] Filter by term IDs (participants who have participation in any of the given terms)
         * @param {TestTermParticipantStatusDto} [termStatus] Filter by term participation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStageParticipants(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, termIds?: Array<number>, termStatus?: TestTermParticipantStatusDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StageParticipantsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStageParticipants(certificationId, stageId, page, pageSize, search, termIds, termStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StageParticipantApi.getStageParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns active employees that are NOT yet participants of the given stage. Used by the \"Dodaj uczestnika do ankiety\" picker — the source-side field of that dialog uses a different endpoint (existing survey participants). 
         * @summary Search employees eligible to be added to the SURVEY stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] Free-text search across first name, last name, email and SAP number.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEligibleSurveyParticipants(certificationId: number, stageId: number, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibleSurveyParticipantsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEligibleSurveyParticipants(certificationId, stageId, search, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StageParticipantApi.listEligibleSurveyParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove participant from stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeStageParticipant(certificationId: number, stageId: number, participantId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeStageParticipant(certificationId, stageId, participantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StageParticipantApi.removeStageParticipant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StageParticipantApi - factory interface
 * @export
 */
export const StageParticipantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StageParticipantApiFp(configuration)
    return {
        /**
         * Adds employees from the certification participant pool to this specific stage. Skips employees already assigned to the stage. 
         * @summary Add participants to stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStageParticipants(certificationId: number, stageId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addStageParticipants(certificationId, stageId, addStageParticipantsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds an employee to a SURVEY stage and assigns specific questions. Either provide questionIds (specific questions to assign) or sourceEmployeeId (copy questions from another participant). Creates stage participant, survey question assignments, survey participant preview, and certification participant records. 
         * @summary Add participant to survey stage with question assignment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {SurveyAssignRequestDto} surveyAssignRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSurveyParticipant(certificationId: number, stageId: number, surveyAssignRequestDto: SurveyAssignRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignSurveyParticipant(certificationId, stageId, surveyAssignRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the IDs of survey questions currently assigned to the given employee in the SURVEY stage. Used by the \"add participant — copy from another participant\" UX to preselect questions before assigning them to a new participant. 
         * @summary List question IDs assigned to an employee in the survey stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSurveyQuestionIds(certificationId: number, stageId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeSurveyQuestionIdsResponseDto> {
            return localVarFp.getEmployeeSurveyQuestionIds(certificationId, stageId, employeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns paginated list of employees assigned to this certification stage. Supports search by employee name/email (partial match). Includes term participation history for each participant. 
         * @summary Get stage participants
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by employee name or email (partial match)
         * @param {Array<number>} [termIds] Filter by term IDs (participants who have participation in any of the given terms)
         * @param {TestTermParticipantStatusDto} [termStatus] Filter by term participation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStageParticipants(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, termIds?: Array<number>, termStatus?: TestTermParticipantStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<StageParticipantsResponseDto> {
            return localVarFp.getStageParticipants(certificationId, stageId, page, pageSize, search, termIds, termStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns active employees that are NOT yet participants of the given stage. Used by the \"Dodaj uczestnika do ankiety\" picker — the source-side field of that dialog uses a different endpoint (existing survey participants). 
         * @summary Search employees eligible to be added to the SURVEY stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} [search] Free-text search across first name, last name, email and SAP number.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEligibleSurveyParticipants(certificationId: number, stageId: number, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSurveyParticipantsResponseDto> {
            return localVarFp.listEligibleSurveyParticipants(certificationId, stageId, search, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove participant from stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} participantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeStageParticipant(certificationId: number, stageId: number, participantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeStageParticipant(certificationId, stageId, participantId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StageParticipantApi - interface
 * @export
 * @interface StageParticipantApi
 */
export interface StageParticipantApiInterface {
    /**
     * Adds employees from the certification participant pool to this specific stage. Skips employees already assigned to the stage. 
     * @summary Add participants to stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApiInterface
     */
    addStageParticipants(certificationId: number, stageId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Adds an employee to a SURVEY stage and assigns specific questions. Either provide questionIds (specific questions to assign) or sourceEmployeeId (copy questions from another participant). Creates stage participant, survey question assignments, survey participant preview, and certification participant records. 
     * @summary Add participant to survey stage with question assignment
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {SurveyAssignRequestDto} surveyAssignRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApiInterface
     */
    assignSurveyParticipant(certificationId: number, stageId: number, surveyAssignRequestDto: SurveyAssignRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns the IDs of survey questions currently assigned to the given employee in the SURVEY stage. Used by the \"add participant — copy from another participant\" UX to preselect questions before assigning them to a new participant. 
     * @summary List question IDs assigned to an employee in the survey stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApiInterface
     */
    getEmployeeSurveyQuestionIds(certificationId: number, stageId: number, employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeSurveyQuestionIdsResponseDto>;

    /**
     * Returns paginated list of employees assigned to this certification stage. Supports search by employee name/email (partial match). Includes term participation history for each participant. 
     * @summary Get stage participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by employee name or email (partial match)
     * @param {Array<number>} [termIds] Filter by term IDs (participants who have participation in any of the given terms)
     * @param {TestTermParticipantStatusDto} [termStatus] Filter by term participation status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApiInterface
     */
    getStageParticipants(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, termIds?: Array<number>, termStatus?: TestTermParticipantStatusDto, options?: RawAxiosRequestConfig): AxiosPromise<StageParticipantsResponseDto>;

    /**
     * Returns active employees that are NOT yet participants of the given stage. Used by the \"Dodaj uczestnika do ankiety\" picker — the source-side field of that dialog uses a different endpoint (existing survey participants). 
     * @summary Search employees eligible to be added to the SURVEY stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] Free-text search across first name, last name, email and SAP number.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApiInterface
     */
    listEligibleSurveyParticipants(certificationId: number, stageId: number, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<EligibleSurveyParticipantsResponseDto>;

    /**
     * 
     * @summary Remove participant from stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApiInterface
     */
    removeStageParticipant(certificationId: number, stageId: number, participantId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * StageParticipantApi - object-oriented interface
 * @export
 * @class StageParticipantApi
 * @extends {BaseAPI}
 */
export class StageParticipantApi extends BaseAPI implements StageParticipantApiInterface {
    /**
     * Adds employees from the certification participant pool to this specific stage. Skips employees already assigned to the stage. 
     * @summary Add participants to stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {AddStageParticipantsRequestDto} addStageParticipantsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApi
     */
    public addStageParticipants(certificationId: number, stageId: number, addStageParticipantsRequestDto: AddStageParticipantsRequestDto, options?: RawAxiosRequestConfig) {
        return StageParticipantApiFp(this.configuration).addStageParticipants(certificationId, stageId, addStageParticipantsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds an employee to a SURVEY stage and assigns specific questions. Either provide questionIds (specific questions to assign) or sourceEmployeeId (copy questions from another participant). Creates stage participant, survey question assignments, survey participant preview, and certification participant records. 
     * @summary Add participant to survey stage with question assignment
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {SurveyAssignRequestDto} surveyAssignRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApi
     */
    public assignSurveyParticipant(certificationId: number, stageId: number, surveyAssignRequestDto: SurveyAssignRequestDto, options?: RawAxiosRequestConfig) {
        return StageParticipantApiFp(this.configuration).assignSurveyParticipant(certificationId, stageId, surveyAssignRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the IDs of survey questions currently assigned to the given employee in the SURVEY stage. Used by the \"add participant — copy from another participant\" UX to preselect questions before assigning them to a new participant. 
     * @summary List question IDs assigned to an employee in the survey stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApi
     */
    public getEmployeeSurveyQuestionIds(certificationId: number, stageId: number, employeeId: string, options?: RawAxiosRequestConfig) {
        return StageParticipantApiFp(this.configuration).getEmployeeSurveyQuestionIds(certificationId, stageId, employeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns paginated list of employees assigned to this certification stage. Supports search by employee name/email (partial match). Includes term participation history for each participant. 
     * @summary Get stage participants
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by employee name or email (partial match)
     * @param {Array<number>} [termIds] Filter by term IDs (participants who have participation in any of the given terms)
     * @param {TestTermParticipantStatusDto} [termStatus] Filter by term participation status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApi
     */
    public getStageParticipants(certificationId: number, stageId: number, page?: number, pageSize?: number, search?: string, termIds?: Array<number>, termStatus?: TestTermParticipantStatusDto, options?: RawAxiosRequestConfig) {
        return StageParticipantApiFp(this.configuration).getStageParticipants(certificationId, stageId, page, pageSize, search, termIds, termStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns active employees that are NOT yet participants of the given stage. Used by the \"Dodaj uczestnika do ankiety\" picker — the source-side field of that dialog uses a different endpoint (existing survey participants). 
     * @summary Search employees eligible to be added to the SURVEY stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} [search] Free-text search across first name, last name, email and SAP number.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApi
     */
    public listEligibleSurveyParticipants(certificationId: number, stageId: number, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return StageParticipantApiFp(this.configuration).listEligibleSurveyParticipants(certificationId, stageId, search, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove participant from stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} participantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StageParticipantApi
     */
    public removeStageParticipant(certificationId: number, stageId: number, participantId: number, options?: RawAxiosRequestConfig) {
        return StageParticipantApiFp(this.configuration).removeStageParticipant(certificationId, stageId, participantId, options).then((request) => request(this.axios, this.basePath));
    }
}

